import { clsx } from "clsx";
import { IconCircle, IconCircleCheckFilled } from "@tabler/icons-react";
import { Text } from "../typography";

export interface CheckOptionProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  name?: string;
  className?: string;
}

/**
 * A circle-checkbox row used in filter drawers and selection lists.
 * Shows a hollow circle when unchecked, filled check-circle when checked.
 */
export function CheckOption({
  label,
  checked,
  onChange,
  disabled = false,
  name,
  className,
}: CheckOptionProps) {
  return (
    <label
      className={clsx(
        // `relative` anchors the sr-only input inside the label; otherwise focusing it on
        // click scrolls the whole page to where it sits in the document (blank screen).
        "relative flex w-full cursor-pointer items-center gap-3 py-1.5",
        disabled && "cursor-not-allowed opacity-60",
        className,
      )}
    >
      <input
        type="checkbox"
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
        className="sr-only"
      />
      <span
        aria-hidden="true"
        className={clsx(
          "inline-flex size-5 shrink-0 items-center justify-center rounded-full transition-colors",
          checked ? "text-textDark" : "text-textMuted",
        )}
      >
        {checked ? (
          <IconCircleCheckFilled size={20} />
        ) : (
          <IconCircle size={20} />
        )}
      </span>
      <Text variant="body" tone="dark" inline>
        {label}
      </Text>
    </label>
  );
}

export default CheckOption;
